import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'Operators list';
export default function AOClpOperatorsList() {
  const initiateTracking = () => {
    $('.js-ao-clp-operators-list__content').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const $clickedElementItem = $clickedElement.closest('.ao-clp-operators-list__item');
      const clickedElementLink = $clickedElement.attr('href');

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(
        EVENT_CATEGORY,
        clickedElementLink,
        `Index: ${$clickedElementItem.index() + 1}`,
      );
    });
  };

  return { initiate: initiateTracking };
}
